import formBaseMixin from  '../../../components/form/form-base-mixin.js'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        billing_account: '',
        value: '',
        dt_payment: '',
        number: '',
        period: ''
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    const promises = []
    const endpoints = [
      methods.getItemEndpoint
    ]

    endpoints.forEach(endpointFunc => {
      let endpoint = endpointFunc(route, fromRoute)
      if (endpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint}))
      }
    })

    return promises.length ? Promise.all(promises) : Promise.resolve(true)
  }
}
